import gql from 'graphql-tag'

const DUPLICA_CONFIGURAZIONE = gql`
  mutation duplica($configurazioneId: Int!) {
    duplica(configurazioneId: $configurazioneId)
  }
`
export default DUPLICA_CONFIGURAZIONE
